<template>
    <div id="mapTestCenter" style="height:200px; width: 395px; z-index:0"></div>
</template>
<script>

import * as L from 'leaflet'
import * as esri_geo from 'esri-leaflet-geocoder'

import LocationTC from "@/services/web-view/lokasi-tc.service"

export default {
    data() {
        return {
            groupMarker : [],
            latitude: 0,
            longtitude: 0,
        }
    },
    mounted() {
        this.getDataTestCenter();
    },
    methods: {
        getDataTestCenter() {
            LocationTC.getPetaSebaran()
            .then(response => {
                this.getKoordinat(response.data.data)
            }).catch(error=>{
                // comment console console.log(error);
            })
        },
        getKoordinat(data) {
        var vm = this;
        
        var customMarker = L.icon({
            iconUrl: '/img/map-marker-alt-solid.svg',
            iconSize: [20, 40],
            iconAnchor: [14, 43.705878]
        });        
        
        var map = L.map('mapTestCenter').setView(
            [-2.811371193331128, 121.55479501146787]
            , 3.3
        );

        L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
            attribution:
            '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);
        var vm = this;

        data.forEach(element => {
            vm.groupMarker.push({
            latitude : element.latitude,
            longitude : element.longitude,
            })
        }) 
        for (let index = 0; index < data.length; index++) {
            var latitude = data[index].latitude;
            var longitude = data[index].longitude;
            var x = parseFloat(latitude);
            var y = parseFloat(longitude); 
            var namaTc = data[index].namaTc;
            L.marker([x, y], { icon: customMarker }).bindPopup(namaTc).addTo(map);
        }
        var arcgisOnline = esri_geo.arcgisOnlineProvider();
        var searchControl = esri_geo.geosearch({
            providers: [arcgisOnline]
        }).addTo(map);
        var results = L.layerGroup().addTo(map);
        },
    }
    
}
</script>